module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-left-7234586e5c242f1da633e29d30fe5268.svg";